/** All available types for standard report columns */
export enum ReportItemColumnTypeEnum {
  /** Simple string value */
  STRING = 'STRING',
  /** Hex color value */
  HEX_COLOR = 'HEX_COLOR',
  /** Simple number value */
  NUMBER = 'NUMBER',
  /** Simple boolean value */
  BOOLEAN = 'BOOLEAN',
  /** Date value */
  DATE = 'DATE',
  /** Enumeration value */
  ENUM = 'ENUM',
  /** FRM entity */
  FRM_ENTITY = 'FRM_ENTITY',
  /** Numeric FRM entity's unique key (ID or code) */
  NUMERIC_FRM_ENTITY_KEY = 'NUMERIC_FRM_ENTITY_KEY',
  /** String entity's primary key (ID or code) */
  STRING_FRM_ENTITY_KEY = 'STRING_FRM_ENTITY_KEY',
  /** Button in user interface */
  BUTTON = 'BUTTON',
  /** Progress bar */
  PROGRESS_BAR = 'PROGRESS_BAR',
}
